import React, { useEffect } from 'react';
import { Form, Card } from 'antd';
import FormItem from '@/common/FormItem';
import styles from '@/common/Layout/index.module.less';
import CustomTable from 'common/Content/CustomTable';
import CustomButton from '@/common/CustomButton';
import { history } from 'app/history';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserMatrix } from '../../redux/slice';
import { roles } from 'utilities/helpers';
import Layout from '@/common/Layout';
import { buildMatrixTransactions, matrixColumns } from '../userMatrix.helper';

const UserMatrix = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParam = location.search;
  const searchParams = new URLSearchParams(searchParam);
  const role = searchParams.get('role') || '';
  const level = parseInt(searchParams.get('level') || '0', 10);
  const { userMatrix, getUserMatrixLoading } = useSelector(
    (state) => state.admin
  );

  useEffect(() => {
    if (role && level) {
      const payload = { role, level };
      dispatch(fetchUserMatrix(payload));
    }
  }, [role, level, dispatch, location.search]);

  const transactions = buildMatrixTransactions(userMatrix);

  return (
    <>
      <Layout sider={false}>
        <Form form={form} layout="vertical">
          <Card
            title={<span>Permission Matrix</span>}
            className={`${styles.cardStyles_approver}`}
          >
            <p style={{ color: '#f536a5' }}>
              Role: <b>{roles(role, level)}</b> , Level: <b>{level}</b>
            </p>
            <div className={`${styles.table_row}`}>
              <CustomTable
                columns={matrixColumns}
                dataSource={transactions}
                pagination={false}
                loading={getUserMatrixLoading}
              />
            </div>
          </Card>
          <br />
          <FormItem className="text-center">
            <CustomButton
              className={styles.inwardButton}
              onClick={() => history.back()}
              type="primary"
            >
              Back
            </CustomButton>
          </FormItem>
        </Form>
      </Layout>
    </>
  );
};

export default UserMatrix;
